

































import { Component, Vue, Watch } from "vue-property-decorator";
import Login from "./component/PfLogin.vue";
import Register from "./component/PfRegister.vue";
import WeChat from "./component/PfWeChat.vue";
import ForGet from "./component/PfForGet.vue";
import BindingLogin from "./component/PfBindingLogin.vue";
import { Getter } from "vuex-class";
@Component({
  components: { Login, Register, WeChat, ForGet, BindingLogin },
})
export default class Hlogin extends Vue {
  @Getter("user/isLogin") public isLogin: any;
  private componentName: string = "WeChat";
  private userInfo: any = null;
  private taskId: any = null;
  private inviteCode: any = null;
  private controlToken: any = null;
  private created() {
    const that = this;
    this.initTaskLogin();
  }
  private initTaskLogin() {
    const taskId: any = this.$route.query.taskId || null;

    if (taskId) {
      sessionStorage.setItem("LoginTaskId", encodeURIComponent(taskId));
      this.taskId = encodeURIComponent(taskId);
    }
    const inviteCode: any = this.$route.query.inviteCode || null;
    if (inviteCode) {
      sessionStorage.setItem("LoginInviteCode", inviteCode);
      this.inviteCode = inviteCode;
    }
  }
  // 跳转不同组件
  private handleGoto(componentName: string, userInfo: any) {
    this.componentName = componentName;
    this.userInfo = userInfo;
    // console.log("userInfo", userInfo);
  }
  // 去首页
  private getIndex() {
    this.$router.push("/index");
  }
}
